<template>
  <el-dialog title='修改台账月' :visible.sync='dialogVisible' width='1100px' center
             @close='dialogClose'>
    <div class='leader-input'>
      <span>请输入台账月：</span>
      <el-date-picker v-model='standingBookMonth' size='mini' value-format='yyyy-MM' type='month'
                      placeholder='请选择台账月' />
      <div style='display:inline-block;width:calc(100% - 300px);text-align:right'>
        <el-button size='small' class='searchBtn' @click='dialogSubmit'>确 定</el-button>
        <el-button size='small' class='resetBtn' @click='dialogClose'>取 消</el-button>
      </div>
    </div>
    <el-table
      v-loading='tableLoading'
      :data='tableData'
      style='width: 100%'
      border
      :header-cell-style="{background:'#E8E8E8',color:'#3B3B3B'}"
    >
      <el-table-column prop='consignorName' label='委托商' min-width='150' show-overflow-tooltip
                       align='center' />
      <el-table-column prop='portName' label='作业港口' min-width='150' show-overflow-tooltip
                       align='center' />
      <el-table-column prop='workType' label='作业类型' min-width='150' show-overflow-tooltip
                       align='center'>
        <template slot-scope='scope'>{{ scope.row.workType |workTypeFormat }}</template>
      </el-table-column>
      <el-table-column prop='batchNumber' label='批次号' min-width='150' show-overflow-tooltip
                       align='center' />
      <el-table-column prop='waybillNo' label='运单编号' min-width='150' show-overflow-tooltip
                       align='center' />
      <el-table-column prop='frameNumber' label='车架号' min-width='150' show-overflow-tooltip
                       align='center' />
      <el-table-column prop='brandName' label='品牌' min-width='100' show-overflow-tooltip
                       align='center' />
      <el-table-column prop='modelName' label='型号' min-width='100' show-overflow-tooltip
                       align='center' />
      <el-table-column prop='standingBookMonth' label='台账月' min-width='120'
                       show-overflow-tooltip align='center' />
      <el-table-column label='操作' align='center'>
        <template slot-scope='scope'>
          <i class='el-icon-error' style='font-size: 20px;'
             @click='dialogDelete(scope.$index)'></i>
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>
  import { updateBatchStandingBookMonth } from '@/service/getData';
  import { supplierPortWarehouseSettlementUpdateBatchStandingBookMonth } from '@/service/warehouse';

  export default {
    name: 'modifyLedgerMonth',
    data() {
      return {
        dialogVisible: false,
        tableLoading: false,
        tableData: [],
        standingBookMonth: '',
      };
    },
    filters: {
      workTypeFormat(value) {
        switch (value) {
          case 1:
            return '装船';
          case 2:
            return '卸船';
          case 3:
            return '过驳';
        }
      },
    },
    methods: {
      dialogOpen(selectedData) {
        this.tableData = selectedData;
        this.dialogVisible = true;
      },
      dialogClose() {
        this.dialogVisible = false;
      },
      async dialogSubmit() {
        const ids = this.tableData.map(item => item.id);
        const {
          status,
          message,
        } = await supplierPortWarehouseSettlementUpdateBatchStandingBookMonth({
          month: this.standingBookMonth,
          ids,
        });
        if (status !== 0) return this.$message.warning(message);
        this.$message.success(message);
        this.dialogClose();
        this.$emit('clearSelectedData');
      },
      dialogDelete(index) {
        this.tableData.splice(index, 1);
      },
    },
  };
</script>

<style lang='scss' scoped>
  .leader-input {
    display: inline-block;
    width: 100%;
    margin-bottom: 15px;

    span {
      display: inline-block;
      width: 100px;
    }

    ::v-deep {
      .el-input.el-input--small {
        display: inline-block;
        width: 200px;
      }
    }
  }
</style>
